<template>
  <HttpContentView :endpoint="utilities.path('servers/@', serverId)" v-model:reload="reload">
    <template v-slot:content="{ data: server }">
      <div class="d-flex flex-column g-4">
        <div class="row g-4">
          <div class="col-6">
            <h4 class="mb-2">{{ translate("name") }}</h4>
            <span>{{ server.name }}</span>
          </div>
          <div class="col-6">
            <h4 class="mb-2">{{ translate("color") }}</h4>
            <i class="fas fa-circle" :style="{ color: server.color }"></i>
          </div>
          <div class="col-12">
            <TargetedModalView>
              <template v-slot:target="{ show }">
                <ButtonView type="normal" color="secondary" class="w-100" @click="show">
                  <div class="d-flex align-items-center justify-content-center g-2">
                    <i class="fas fa-edit"></i>
                    <span>{{ translate("edit") }}</span>
                  </div>
                </ButtonView>
              </template>
              <template v-slot:header="{ hide }">
                <div class="d-flex align-items-center justify-content-between">
                  <h3 class="mb-0">{{ translate("server") }}</h3>
                  <ModalCloseButtonView @click="hide"/>
                </div>
              </template>
              <template v-slot:body="{ hide }">
                <ServerFormView :community-id="communityId" :editing="server" @dismiss="hide" @update="hide(); reload = true; emit('update')"/>
              </template>
            </TargetedModalView>
          </div>
          <div v-if="server.addonVersion" class="col-6">
            <h4 class="mb-2">{{ translate("addon_version") }}</h4>
            <span>{{ server.addonVersion }}</span>
          </div>
          <div v-if="server.ip" class="col-6">
            <h4 class="mb-2">{{ translate("ip") }}</h4>
            <div>{{ server.ip }}</div>
          </div>
          <div v-if="serverCountUsage.value.exceeded === false" class="col-12">
            <div class="d-flex align-items-center g-4">
              <TargetedModalView class="w-100">
                <template v-slot:header="{ hide }">
                  <div class="d-flex align-items-center justify-content-between g-4">
                    <h3 class="mb-0">{{ translate('servers.resetToken') }}</h3>
                    <ModalCloseButtonView @click="hide"/>
                  </div>
                </template>
                <template v-slot:target="{ show }">
                  <ButtonView type="soft" color="warning" class="w-100" @click="show">
                    <div class="d-flex align-items-center justify-content-center g-2">
                      <i class="fas fa-undo"></i>
                      <span>{{ translate("servers.resetToken") }}</span>
                    </div>
                  </ButtonView>
                </template>
                <template v-slot:body="{ hide }">
                  <HttpFormView :endpoint="utilities.path('servers/@/token/reset', server.id)" method="post" @success="hide(); emit('setup', $event)">
                    <template v-slot:form="{ submit, loading }">
                      <div>{{ translate("servers.token.reset.description") }}</div>
                      <div class="d-flex align-items-center g-4 mt-4">
                        <ButtonView type="normal" color="warning" class="w-100" @click="submit">
                          {{ translate('servers.resetToken') }}
                        </ButtonView>
                        <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                          {{ translate("cancel") }}
                        </ButtonView>
                      </div>
                      <SpinnerView :active="loading" color="warning"/>
                    </template>
                  </HttpFormView>
                </template>
              </TargetedModalView>
              <TargetedModalView class="w-100">
                <template v-slot:header="{ hide }">
                  <div class="d-flex align-items-center justify-content-between g-4">
                    <h3 class="mb-0">{{ translate('servers.resetIp') }}</h3>
                    <ModalCloseButtonView @click="hide"/>
                  </div>
                </template>
                <template v-slot:target="{ show }">
                  <ButtonView type="soft" color="primary" class="w-100" @click="show">
                    <div class="d-flex align-items-center justify-content-center g-2">
                      <i class="fas fa-undo"></i>
                      <span>{{ translate("servers.resetIp") }}</span>
                    </div>
                  </ButtonView>
                </template>
                <template v-slot:body="{ hide }">
                  <HttpFormView :endpoint="utilities.path('servers/@/ip/reset', server.id)" method="post" @success="hide(); reload = true; emit('update')">
                    <template v-slot:form="{ submit, loading }">
                      <div>{{ translate("servers.ip.reset.description") }}</div>
                      <div class="d-flex align-items-center g-4 mt-4">
                        <ButtonView type="normal" color="primary" class="w-100" @click="submit">
                          {{ translate('servers.resetIp') }}
                        </ButtonView>
                        <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                          {{ translate("cancel") }}
                        </ButtonView>
                      </div>
                      <SpinnerView :active="loading" color="primary"/>
                    </template>
                  </HttpFormView>
                </template>
              </TargetedModalView>
            </div>
          </div>
        </div>
      </div>
    </template>
  </HttpContentView>
</template>

<script setup>
import {ButtonView, HttpFormView, ModalCloseButtonView, HttpContentView, SpinnerView, TargetedModalView, utilities} from "@niftybit/vue";
import ServerFormView from "@/systems/community/views/ServerFormView.vue";
import {ref} from "vue";

defineProps({
  communityId: String,
  serverCountUsage: Object,
  serverId: String
});

const emit = defineEmits(["setup", "update"]);

const reload = ref(false);

</script>